import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PublicUser, Right } from '@wave/shared';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: PublicUser | null;
  rights: Right[];
  setSession: (data: { accessToken: string; refreshToken: string; user: PublicUser }) => void;
  setRights: (rights: Right[]) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      rights: [],
      setSession: ({ accessToken, refreshToken, user }) => set({ accessToken, refreshToken, user }),
      setRights: (rights) => set({ rights }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null, rights: [] }),
    }),
    { name: 'wave-auth' },
  ),
);

export function hasRight(rights: Right[], required: Right): boolean {
  return rights.includes(required);
}
